export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="7" fill="#0B1530" stroke="rgba(201,165,92,.45)" />
    <path d="M16 28V9" stroke="#C9A55C" strokeWidth="1.6" strokeLinecap="round" />
    <g fill="#C9A55C">
      <ellipse cx="16" cy="6.8" rx="2" ry="3.6" />
      {[12.6, 17.8, 23].map((y) => (
        <g key={y}>
          <ellipse cx="12.7" cy={y} rx="1.8" ry="3.4" transform={`rotate(-38 12.7 ${y})`} />
          <ellipse cx="19.3" cy={y} rx="1.8" ry="3.4" transform={`rotate(38 19.3 ${y})`} />
        </g>
      ))}
    </g>
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-2xl font-extrabold tracking-wide leading-none">
      MB<span className="text-[var(--gold)]">300</span>
    </span>
  </span>
);
